import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Message type for postMessage communication
export interface ClearanceFeedbackMessage {
  type: 'CLEARANCE_FEEDBACK';
  isSuccess: boolean;
  data?: {
    transactionId?: string;
    confirmationKey?: string;
    approvalNo?: string;
    statusCode?: string;
    statusDescription?: string;
  };
}

export interface ClearanceFeedbackProps {
  isSuccess: boolean;
}

export const ClearanceFeedback: React.FC<ClearanceFeedbackProps> = ({
  isSuccess,
}) => {
  const [searchParams] = useSearchParams();

  // Get additional data from URL if available
  const transactionId =
    searchParams.get('PelecardTransactionId') ||
    searchParams.get('transactionId');
  const confirmationKey = searchParams.get('ConfirmationKey');
  const approvalNo = searchParams.get('ApprovalNo');
  const statusCode =
    searchParams.get('PelecardStatusCode') || searchParams.get('statusCode');
  const statusDescription = searchParams.get('StatusDescription');

  useEffect(() => {
    // Send postMessage to parent window
    const message: ClearanceFeedbackMessage = {
      type: 'CLEARANCE_FEEDBACK',
      isSuccess,
      data: {
        transactionId: transactionId || undefined,
        confirmationKey: confirmationKey || undefined,
        approvalNo: approvalNo || undefined,
        statusCode: statusCode || undefined,
        statusDescription: statusDescription || undefined,
      },
    };

    // Send message to parent window
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(message, '*');
      console.log('Sent postMessage to parent:', message);
    }
  }, [
    isSuccess,
    transactionId,
    confirmationKey,
    approvalNo,
    statusCode,
    statusDescription,
  ]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
        backgroundColor: isSuccess ? '#E8F5E9' : '#FFEBEE',
        direction: 'rtl',
      }}
    >
      {isSuccess ? (
        <>
          <div
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#4CAF50',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '24px',
            }}
          >
            <i
              className="pi pi-check"
              style={{ fontSize: '40px', color: 'white' }}
            ></i>
          </div>
          <h1
            style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#2E7D32',
              marginBottom: '12px',
            }}
          >
            התשלום בוצע בהצלחה!
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#388E3C',
              textAlign: 'center',
            }}
          >
            פרטי כרטיס האשראי נשמרו בהצלחה
          </p>
          {transactionId && (
            <p
              style={{
                fontSize: '14px',
                color: '#666',
                marginTop: '16px',
              }}
            >
              מספר עסקה: {transactionId}
            </p>
          )}
        </>
      ) : (
        <>
          <div
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#F44336',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '24px',
            }}
          >
            <i
              className="pi pi-times"
              style={{ fontSize: '40px', color: 'white' }}
            ></i>
          </div>
          <h1
            style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#C62828',
              marginBottom: '12px',
            }}
          >
            התשלום נכשל
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#D32F2F',
              textAlign: 'center',
            }}
          >
            אירעה שגיאה בעת ביצוע התשלום
          </p>
          {statusDescription && (
            <p
              style={{
                fontSize: '14px',
                color: '#666',
                marginTop: '16px',
              }}
            >
              {statusDescription}
            </p>
          )}
        </>
      )}
    </div>
  );
};
